import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=26eabb2f&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26eabb2f')) {
      api.createRecord('26eabb2f', component.options)
    } else {
      api.reload('26eabb2f', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=26eabb2f&", function () {
      api.rerender('26eabb2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Access/Approved/DeleteModal.vue"
export default component.exports